<!-- nav -->
@if (userConnected | async) {
  <!--  header -->
  @if (!isMobileApp) {
    <nav app-header></nav>
  }
  <main id="main" [class]="isMobileApp ? 'mobile-app' : ''">
    <mat-sidenav-container [class.mt-0]="isMobileApp" (backdropClick)="onBackDropClick()">
      <mat-sidenav
        id="main-side-nav"
        #snav
        [mode]="navMode"
        [fixedInViewport]="navFixedInViewport"
        fixedTopGap="56"
        [(opened)]="opened"
      >
        @if (!isNavigationDisabled()) {
          <app-main-menu></app-main-menu>
        }
      </mat-sidenav>
      <mat-sidenav-content #snavcontent>
        <app-assumed-user-disconnect></app-assumed-user-disconnect>
        <div>
          <ng-container *ngTemplateOutlet="mainContent"></ng-container>
        </div>
        <footer class="app-version">v{{ appVersion }}</footer>
      </mat-sidenav-content>
    </mat-sidenav-container>
  </main>
  <app-help-scout-widget></app-help-scout-widget>
  <div id="swiper-overlay-container"></div>
}

<!-- public app container -->
@if ((userConnected | async) === false) {
  <div id="login-wrap">
    <div class="bkg">&nbsp;</div>
    <div class="wrap-split">
      <!-- left -->
      <div class="split-part login-left">
        <img src="assets/images/logo_eemo_white.svg" width="140" alt="EEMO" />
        <p>L'<i>eemobilier</i> en toute simplicité - test</p>
      </div>
      <!-- right -->
      <div class="split-part login-right">
        <ng-container *ngTemplateOutlet="publicContent"></ng-container>
      </div>
    </div>
  </div>
}

@if (appConfigService.isDev() || appConfigService.isDemo()) {
  <div class="env">
    @if (appConfigService.isDev()) {
      <span class="text-warning">Dev</span>
    }
    @if (appConfigService.isDemo()) {
      <span class="text-warning">Démo</span>
    }
  </div>
}

<ng-template #publicContent>
  <app-alert></app-alert>
  <router-outlet (activate)="onActivate($event)"> </router-outlet>
</ng-template>

<ng-template #mainContent>
  <app-alert></app-alert>
  <app-subscription-alert></app-subscription-alert>
  <app-float-menu></app-float-menu>
  <router-outlet (activate)="onActivate($event)"> </router-outlet>
</ng-template>
